import gdp from "gio-webjs-sdk-cdp/gdp-full";
import { getCurrentUid } from "../api/common";
import { getChannel, getClientEnv, getQueryObj } from "./tools";

const accountIdMap = {
  test: "89a922449121f7c2",
  deploy: "89a922449121f7c2",
  product: "84eafaa69d23412f",
};
const datasourceIdMap = {
  test: "ab792bc691554c4d",
  deploy: "ab792bc691554c4d",
  product: "bafd9e977149be4c",
};
const hostMap = {
  test: "collect.test.xiaopeng.com",
  deploy: "collect.test.xiaopeng.com",
  product: "collect.xiaopeng.com",
};

const accountId = accountIdMap[getClientEnv()];
const datasourceId = datasourceIdMap[getClientEnv()];
const defaultConfig = {
  host: hostMap[getClientEnv()],
  version: "1.0.0",
  autotrack: false, // 无埋点开关
  hashtags: true, // 是否开启hashtag
};
const defaultParams = {
  user_channel: getChannel(),
};
const eventPrefix = "charge_H5";

export const USER_TYPE_TO_NAME = {
  "1": "车主",
  "2": "普通用户",
  "3": "租客",
  "4": "授权使用人",
  "-1": "未知",
};

export function initGdp(config?: object) {
  const queryObj = getQueryObj();

  if (queryObj.giodatacollect === "true") {
    // 识别到是在小程序中，使用小程序的配置
    gdp(
      "init",
      queryObj.gioprojectid,
      queryObj.giodatasourceid,
      queryObj.gioappid,
      Object.assign(defaultConfig, config),
    );
  } else {
    gdp("init", accountId, datasourceId, Object.assign(defaultConfig, config));
  }

  console.log("gdp getOption", gdp("getOption"));

  if (process.env.NODE_ENV === "development") {
    gdp("setOption", "debug", true);
  }
}

export async function trackGdp(
  pageId: string,
  buttonId: string,
  params?: Record<string, any>,
) {
  try {
    const uid = await getCurrentUid();
    defaultParams["userId"] = uid;
    defaultParams["user_id"] = uid;
    defaultParams["userID"] = uid;
    defaultParams["pageId"] = pageId;
    defaultParams["buttonId"] = buttonId;
    // 组件类型映射
    let map = {
      "base-text": "文本组件",
      "base-image": "图片组件",
      "base-video": "视频组件",
      "base-tab": "TAB组件",
      base_music: "音乐组件",
      "base-pop": "悬浮窗组件",
      "swiper-banner": "轮播图组件",
      "grid-menu": "金刚位组件",
      "busi-prize": "领奖组件",
      "busi-stairs": "阶梯组件",
      "busi-raffle": "抽奖组件",
      "busi-ranking": "打榜组件",
      dynamicStation: "动态场站组件",
      fixedStation: "固定场站组件",
    };

    if (params?.type) {
      params.type = map[params.type] || params.type;
    }
    gdp("setUserId", uid);
    gdp("track", `${eventPrefix}_${pageId}_${buttonId}`, {
      ...defaultParams,
      ...params,
    });
    console.log(
      "===== 埋点上报完成 ======",
      `pageId: ${pageId} | buttonId: ${buttonId}`,
      `| 参数：${JSON.stringify({ ...defaultParams, ...params })}`,
    );
  } catch (e) {
    console.log("埋点上报失败", e);
  }
}
